module.exports = __webpack_public_path__ + "static/media/logo-l.a7624973.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo-l.svg
// module id = 577
// module chunks = 17